"use client";

// import Image, { type StaticImageData } from "next/image";

import panelBg from "./assets/panel-bg.png";
import checkImg from "./assets/check.png";
import coinbag from "./assets/coinbag.png";
import coin60 from "./assets/coin-60.png";
import coin120a from "./assets/coin-120a.png";
import coin120b from "./assets/coin-120b.png";
import coin1280 from "./assets/coin-1280.png";
import coin3280 from "./assets/coin-3280.png";
import coin6480 from "./assets/coin-6480.png";
import { useContext, useEffect, useRef, useState } from "react";
// import { getRechargeConfig } from "@/app/[lang]/recharge/service";
// import { Dict, RechargeConfig } from "@/app/lib/definitions";
// import AppContext from "@/app/common/context";
// import { getFromLocalStorage, setToLocalStorage, tryToReportMp, genPaymentCallbackLink, genPaymentRedirectLink } from "@/app/common/util";
import { createDiamondOrder, getRechargeConfig } from "./service";
import { genPaymentCallbackLink, genPaymentRedirectLink, setToLocalStorage } from "@common/util";
// import Config from "@/app/config";
// import { createDiamondOrder } from "@/app/[lang]/pay/service";
// import { EVENT_COMMON_TIP } from "@/app/common/event";
// import Loading from "../loading";
// import PayChannels from "../payChannels";

interface CoinPack {
    img: any;
}

const COIN_PACKS: CoinPack[] = [
    { img: coin60 },
    { img: coin120a },
    { img: coin120b },
    { img: coin1280 },
    { img: coin3280 },
    { img: coin6480 },
];

type RechargeConfig = {
    configId: number
    payFee: number
    diamondAmount: number
    firstActivityAmount: number
    oriFee: number
    discountFee: number
    firstActivity: number
    purchaseId?: string
}

function CloseIcon() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
                d="M7.7 7.7L16.3 16.3M16.3 7.7L7.7 16.3"
                stroke="#867485"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default function DiamondNeed(
    { userInfo, onClose, }: { userInfo:any, lang: string, locationCode?: string, onClose: () => void }
) {
    const [configs, setConfigs] = useState<RechargeConfig[]>([]);
    const [chosenPlan, setChosenPlan] = useState(0);
    const [price, setPrice] = useState('')
    const [isLoading, toggleLoadingState] = useState(false)

    const submitFlag = useRef(false)

    useEffect(() => {
        getDiamondConfigs();
    }, [])

    const getDiamondConfigs = () => {
        getRechargeConfig().then((data: any) => {
            console.log(data);
            const slice = data.slice(0, 6);
            setConfigs(slice);
            if (slice?.[0]) {
                setChosenPlan(slice[0].configId)
                setPrice(slice[0]?.payFee + '')
            }

        })
    }

    const onItemSel = (config: RechargeConfig) => {
        setChosenPlan(config.configId);
        setPrice(config.payFee + '')
    }

    const goToPay = (e: React.MouseEvent) => {
        if (!userInfo.isLogin) {
            // return toggleLoginDialog(true)
            return;
        }
        const item = configs.find(i => i.configId === chosenPlan)
        if (!item) {
            return
        }
        // const reportValue = encodeURIComponent(JSON.stringify({
        //     order_money: item.payFee,
        //     coin_amount: item.diamondAmount,
        //     source_desc: getFromLocalStorage(Config.PaySceneCacheKey) || ''
        // }))
        // window.ST && window.ST.webTJ && window.ST.webTJ.reportEvent({
        //     category: 'coin_recharge',
        //     label: 'confirm_recharge',
        //     action: 'click',
        //     value: reportValue
        // }, e.nativeEvent)
        // window.ST && window.ST.webTJ && window.ST.webTJ.reportEvent({
        //     category: 'card_pay',
        //     label: 'card_pay',
        //     action: 'open',
        //     value: reportValue
        // })
        // setTimeout(() => { router.push(getLinkByLang(lang, '/pay')) }, 0)
        if (submitFlag.current) {
            return
        }
        submitFlag.current = true
        toggleLoadingState(true)
        // tryToReportMp('trackCustom', 'buy_now', { currency: 'USD', value: item.payFee })
        createDiamondOrder(chosenPlan, 27, '', `${window.location.origin}/?from_scene=pay&pay_type=recharge`, item.purchaseId || '').then((data: any) => {
            submitFlag.current = false
            toggleLoadingState(false)
            const { jumpUrl, orderId } = data
            setToLocalStorage('_poi', orderId)
            window.location.href = jumpUrl
        }).catch((e: Error) => {
            submitFlag.current = false
            toggleLoadingState(false)
            // PubSub.publish(EVENT_COMMON_TIP, { channel: 1, message: e.message })
        })
    }

    return (
        <div className=" fixed left-0 top-0 flex min-h-screen w-full items-center justify-center z-10">
            <div className="absolute inset-0 z-0 bg-black/50 backdrop-blur-[2px]" />
            {/* Modal */}
            <div className=" absolute w-full max:h-[calc(100dvh-61px)] bottom-0 md:relative block md:flex md:h-[659px] md:w-[687px] overflow-y-scroll overflow-x-hidden md:overflow-hidden rounded-xl bg-[#1D191D]">
                {/* close button */}
                <button
                    type="button"
                    onClick={onClose}
                    className="absolute right-[16px] top-[24px] flex h-6 w-6 items-center justify-center z-20 cursor-pointer"
                    aria-label="Close"
                >
                    <CloseIcon />
                </button>
                {/* <div className="relative flex h-fit md:h-full w-[404px] shrink-0 flex-col overflow-hidden">
                    <img
                        src={panelBg}
                        alt=""
                        className="pointer-events-none absolute inset-0 h-full w-full"
                    />

                    <h2 className="relative w-full mt-11 md:mt-[54px] w-[301px] text-center text-[18px] text-2xl custom-bold leading-[29.26px] text-[#F0F0F0]">
                        Not Enough Coins
                    </h2>

                    <img
                        src={coinbag}
                        alt="Coins"
                        className="pointer-events-none relative ml-[88px] md:ml-[38px] md:mt-[-1px] w-50 h-50 md:h-[291px] md:w-[302px]"
                    />

                    <div className="relative mt-[10px] ml-5 md:ml-[66px] w-[246px]">
                        <h3 className="text-[16px] text-lg custom-bold leading-[21.94px] text-white">
                            What Coins Can Do:
                        </h3>
                        <ul className="mt-[20px] flex flex-col gap-[20px]">
                            {FEATURES.map((feat) => (
                                <li
                                    key={feat}
                                    className="flex h-5 items-center gap-2.5"
                                >
                                    <Image
                                        src={checkImg}
                                        alt=""
                                        className="h-4 w-4 shrink-0"
                                    />
                                    <span className="text-[14px] text-base custom-medium leading-[19.5px] whitespace-nowrap text-[#F0F0F0]">
                                        {feat}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div> */}

                {/* ===================== RIGHT PANEL ===================== */}
                <div className="relative h-fit w-full md:h-full md:flex-1 md:pt-15 md:px-[56px]">

                    {/* section title */}
                    <h2 className=" hidden md:block relative text-left text-lg custom-bold leading-[21.94px] text-white">
                        Buy Coins
                    </h2>

                    {/* coin grid */}
                    <div className=" relative ml-5 md:ml-0 mt-11 flex flex-row whitespace-nowrap md:grid w-[calc(100vw-20px)] md:w-[577px] md:grid-cols-3 md:gap-x-[18px] gap-x-2.5 pr-5 md:pr-0 md:gap-y-[17px] overflow-x-scroll md:overflow-hidden">
                        {configs.map((pack, i) => (
                            <div
                                onClick={() => onItemSel(pack)}
                                key={i}
                                className={`flex shrink-0 w-[102px] h-[108px] md:h-[150px] md:w-[180px] flex-col items-center rounded-[12.6px] border pt-0 md:pt-[15px] cursor-pointer ${pack.configId === chosenPlan
                                    ? "border-[#FF3773] bg-[rgba(255,55,115,0.10)]"
                                    : "border-[rgba(240,240,240,0.08)] bg-[rgba(36,30,35,0.70)]"
                                    }`}
                            >
                                <img
                                    src={COIN_PACKS[i].img}
                                    alt=""
                                    className="pointer-events-none h-[44px] w-[82px] md:h-[58px] md:w-[108px]"
                                />
                                <span className="mt-[3px] text-[18px] md:text-2xl custom-bold leading-[29.26px] text-white">
                                    {pack.diamondAmount}
                                </span>
                                <span className="mt-[5px] text-[14px] md:text-base custom-medium leading-[19.5px] text-[#28EAFF]">
                                    ${pack.payFee}
                                </span>
                            </div>
                        ))}
                    </div>
                    {/* <div className="mt-12.5">
                        <PayChannels defaultPayChannel={defaultPayChannel} defaultLinkId={defaultPayLinkId} locationCode={locationCode} onPayChannelChanged={setPayChannel} onLinkIdChanged={setPayLinkId} dict={dict} type='diamond' />
                    </div> */}

                    {/* confirm + total */}
                    <div className="w-[327px] mx-auto mt-4 md:w-[440px] pb-11 md:pb-0">
                        <button
                            onClick={goToPay}
                            type="button"
                            className="flex h-[60px] w-full items-center justify-center rounded-xl bg-[#FF3773] cursor-pointer"
                        >
                            <span className="text-base custom-bold leading-[19.5px] text-white">
                                Confirm
                            </span>
                        </button>
                        <p className="mt-[20px] text-center text-base custom-medium leading-[19.5px] text-[#F0F0F0]">
                            Total：${price}
                        </p>
                    </div>
                </div>
            </div>
            {isLoading &&<div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-black/60 backdrop-blur-sm animate-fade-in">
                <div className="flex flex-col items-center justify-center p-6 bg-white/10 rounded-2xl shadow-xl border border-white/10 max-w-xs w-full">
                    <p className="text-white text-lg font-medium tracking-wide mb-4 select-none">
                    Yoomet
                    </p>
                    <div className="flex items-center space-x-2 h-3">
                    <span className="w-2.5 h-2.5 bg-white rounded-full animate-[pulse-dot_1.4s_infinite_ease-in-out_0s]"></span>
                    <span className="w-2.5 h-2.5 bg-white rounded-full animate-[pulse-dot_1.4s_infinite_ease-in-out_0.2s]"></span>
                    <span className="w-2.5 h-2.5 bg-white rounded-full animate-[pulse-dot_1.4s_infinite_ease-in-out_0.4s]"></span>
                    </div>

                </div>
            </div>}
        </div>
    );
}
